import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { ETransportType } from '../../../common/types';
import { HTMLText } from '../../../components/SEO';
import { City } from '../../../services/cities/types';
import { CompaniesData } from '../../../services/data/types';
import messages from './messages';
import { Title } from './SearchViewContent';

type BestCompanyProps = {
  companiesData: CompaniesData;
  transportType: ETransportType;
  originCity: City;
  destinationCity: City;
  intl: any;
};

const BestCompany = (props: BestCompanyProps) => {
  const { companiesData, destinationCity, intl, originCity, transportType } =
    props;
  const availableCompanies = Object.keys(companiesData || {});

  if (!transportType || !companiesData || availableCompanies.length < 2) {
    return null;
  }

  let cheapestCompany = null;
  let fastestCompany = null;
  let mostFrequentCompany = null;

  let minPrice = Infinity;
  let minDuration = Infinity;
  let maxTrips = 0;

  availableCompanies.forEach((company) => {
    const data = companiesData[company];

    if (data.priceCents.mean < minPrice) {
      minPrice = data.priceCents.mean;
      cheapestCompany = company;
    }

    if (data.durationMinutes.mean < minDuration) {
      minDuration = data.durationMinutes.mean;
      fastestCompany = company;
    }

    if (data.dailyTrips > maxTrips) {
      maxTrips = data.dailyTrips;
      mostFrequentCompany = company;
    }
  });

  if (!cheapestCompany || !fastestCompany || !mostFrequentCompany) {
    return null;
  }

  const messageValues = {
    transportType: intl.formatMessage(messages[transportType]),
    origin: originCity.name,
    destination: destinationCity.name,
  };

  return (
    <div>
      <Title>
        <FormattedHTMLMessage
          {...messages.bestCompanyTitle}
          values={messageValues}
        />
      </Title>

      <ul>
        <HTMLText as="li">
          <FormattedMessage
            {...messages.averageCheapestCompany}
            values={{ ...messageValues, companyName: cheapestCompany }}
          />
        </HTMLText>
        <HTMLText as="li">
          <FormattedMessage
            {...messages.fastestCompany}
            values={{ ...messageValues, companyName: fastestCompany }}
          />
        </HTMLText>
        <HTMLText as="li">
          <FormattedMessage
            {...messages.mostFlexibleCompany}
            values={{ ...messageValues, companyName: mostFrequentCompany }}
          />
        </HTMLText>
      </ul>
    </div>
  );
};

export const BestCompanyIntl = injectIntl(BestCompany);
